import React, { useContext, useEffect, useState } from "react";
import { Combobox, ComboboxProps, Field, FlatTree,TreeItem, TreeItemLayout, useHeadlessFlatTree_unstable, useId, useRestoreFocusTarget,Option, CardPreview, Card, CardFooter, Button } from "@fluentui/react-components";
import { InvestmentService } from "../../service/InvestmentService";
import { useInvestmentStyles,  useStackClassNameWithScrollbar } from "./style/investment.style";
import { DatabaseRegular,  DocumentCheckmarkRegular, FolderRegular } from "@fluentui/react-icons";
import { AppContext } from "./context/AppContext";
import { useLocation,useNavigate } from "react-router-dom";
import SelectionSetSubHeader from "./SelectionSetSubHeader";
import Loader from "./Loader";
import { isValidUser } from "../../utils/common";
const SelectionSet = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectionSetsList, setSelectionSetsList] = useState([]);
  const [dataSelectionSetsList, setDataSelectionSetsList] = useState([]);
  const [stateData,setStateData]=useState(null);
  const investmentService = new InvestmentService();
  const styles = useInvestmentStyles();
  const context = useContext(AppContext);
  const location = useLocation();
  const investmentData = location.state;
  const navigate = useNavigate();
  
  useEffect(() => {
    if(isValidUser()){
      navigate("/home");
    } else {
      const getSelectionSetList = async () => {
          try {
          const result = await investmentService.getSelectionSets(context.selectedProfile.profileID);
          if(Array.isArray(result) && result.length>0){
          const portfolioType = investmentData.portfolioType[0];
          const type = portfolioType.toUpperCase() === "INVESTMENTS" ? portfolioType.slice(0, -1) : portfolioType.toUpperCase() === "INVESTORS" ? "FUND INVESTORS" :portfolioType;
          const filteredList = result.filter(item => item.type.toUpperCase() === type.toUpperCase())
          .sort((a,b) => (a.isFolder < b.isFolder) ? 1 : ((b.isFolder < a.isFolder) ? -1 : 0));
          const flatTreeItems = buildTreeData(filteredList);
          setSelectionSetsList(flatTreeItems);
          setDataSelectionSetsList(flatTreeItems);
          }
          } catch (error) {
            console.log("Error: " + error);
          } finally {
            setIsLoading(() => false);
          }
      };    
      getSelectionSetList();
    }
  }, []);

  const buildTreeData = (nodes) => {
      const result = [];

      // Recursive function to build the tree
      const buildTree = (parentId) => {
          const children = nodes.filter(subNode => subNode.parentID == parentId);;
          children.forEach(node => {
              result.push({
                  value: node.id.toString(),
                  name: node.name,
                  isFolder: node.isFolder,
                  parentValue: node.parentID === "" ? undefined : node.parentID
              });
              buildTree(node.id);
          });
      };

      // Start building the tree from the root nodes (parentID = "")
      buildTree("");
      return result;
  };

  const handleNodeSelect = (id,name) => {
    const returnData = { portfolioType: investmentData.portfolioType,
        portfolio:investmentData.portfolio,
        portfolioValue:investmentData.portfolioValue,
        selectionSetId:id,
        selectionSetName:name };
        setStateData(returnData);
   
  };
  
  const renderTreeItems = () => {  
      const flatTree = useHeadlessFlatTree_unstable(selectionSetsList);
      const focusTargetAttribute = useRestoreFocusTarget();
      return (
          <FlatTree {...flatTree.getTreeProps()} aria-label="Flat Tree">
              {Array.from(flatTree.items(), (flatTreeItem) => {
                  const { name, isFolder, ...treeItemProps } = flatTreeItem.getTreeItemProps();
                  return (
                      <TreeItem  key={treeItemProps.value}  
                          aria-description="has actions"
                          {...focusTargetAttribute}
                          {...treeItemProps} >
                          <TreeItemLayout expandIcon={
            isFolder ? (
              <FolderRegular />
            ) : (
              <DocumentCheckmarkRegular />
            )
          } ><span className="fui-Radio rm0dkue fui-TreeItemLayout__selector">
          <input type="radio" title={name} name="tree-radio" onClick={() => handleNodeSelect(treeItemProps.value,name)} className="fui-Radio__input rg1upok ___183j3wl_1dim0pv f9ma1gx" value={treeItemProps.value} />
          <div aria-hidden="true" className="fui-Radio__indicator rwtekvw">
          </div></span>
            {name}
            </TreeItemLayout>
                      </TreeItem>
                  );
              })}
          </FlatTree>
      );
  };
  const renderComboboxList=() =>{
    const comboId = useId("combo-default");
    const options = dataSelectionSetsList.map(item => (item.name));
    const [matchingOptions, setMatchingOptions] = React.useState([]);
    const onOptionSelect: ComboboxProps['onOptionSelect'] = (e, data) => {
      console.log(e);
      const modifyedItems = dataSelectionSetsList.filter(items=>items.name==data.optionText).map(item=>({value: item.value,
        name: item.name,
        type: item.type,
        isFolder: item.isFolder,
        parentValue: undefined}));
        setSelectionSetsList(modifyedItems);
    };
    const onChange: ComboboxProps["onChange"] = (event) => {
        if(isValidUser()){
          navigate("/home");
        } else {
        const value = event.target.value.trim();
        setMatchingOptions([]);
       if(value.length>2){
          const matches = options.filter(
            (option) => option.toLowerCase().includes(value.toLowerCase())
          );
          setMatchingOptions(matches);
        }
       else if(value.length<1)
        {
            setTimeout(() => {
                setSelectionSetsList(dataSelectionSetsList);
            },0);
        }
      }
      };
      
    return (
        <Combobox
        aria-labelledby={comboId}
        freeform
        onOptionSelect={onOptionSelect}
        placeholder="Search"
        onChange={onChange}
      >
        {matchingOptions.map((option) => (
          <Option key={option}>{option}</Option>
        ))}
       </Combobox>
    );
  };
  const getSelectionSetClickHandler  =()=>{
    if(stateData!==null){
       navigate("/Investment", { state: stateData });
    }
  }
  return (
      <>
      <SelectionSetSubHeader rollbackData={investmentData} title="Selection Set" subtitle="Data" icon={<DatabaseRegular></DatabaseRegular>}></SelectionSetSubHeader>
      <div className={styles.root}>
        <Card className={styles.card} appearance="subtle">
        <CardPreview className={styles.cardPreview}>
        <div className={useStackClassNameWithScrollbar()}>
          <Field className={styles.divider}>
           {renderComboboxList()}
          </Field>
          <Field className={styles.divider}>
              {renderTreeItems()}
          </Field>
        </div>
        </CardPreview>
        <CardFooter dir="rtl">
            <Button
              key="getInvest"
              appearance="primary"
              size="small"
              onClick={getSelectionSetClickHandler}
              className={styles.button}
            >
              Select
            </Button>
          </CardFooter>
      </Card>
      {isLoading && <Loader></Loader>}
     </div>
      </>
  );
};

export default SelectionSet;